export default __webpack_public_path__ + "static/desktop_9-49b5665813111c854539602cf36a9444.webp";